module.exports = __webpack_public_path__ + "img/20200507_141052.74f2f7ab.jpg";